interface Options {
    title: String;
    description?: string;
}

const StepTitle = ({ title, description }: Options) => {
    return (
        <section className="pt-8 md:pt-16 pb-[18px] px-4 md:px-0">
            <h2 className="mb-3 text-2xl md:text-[32px] font-bold text-gray-bb-1 font-title leading-none">{title}</h2>
            {description && <div dangerouslySetInnerHTML={{ __html: description }} className="text-gray-bb-1 text-base md:text-[18px] font-medium"></div>}
        </section>
    );
};

export default StepTitle;
